import dayjs from 'dayjs';
import React from 'react';

import { COLORS } from '../../../../../utils/constants/colors';
import { CellRendererProps } from '../../DataTable.types';

export const DateCellRenderer: React.FC<CellRendererProps> = ({ value }) => {
    const formattedDate = value ? dayjs(value) : null;
    const dateText = formattedDate?.isValid() ? formattedDate.format('DD MMM YYYY') : '-';

    return <div style={{ color: COLORS.LIGHT_GREY }}>{dateText}</div>;
};
